import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { typography, colors } from '@atlaskit/theme';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';
import AutoDismissFlag from '@atlassian/jira-flags/src/common/ui/components/ak-auto-dismiss-flag';
import FlagGroup from '@atlassian/jira-flags/src/common/ui/components/group-flag';
import type { Props } from './types';

const SearchTransitionToggle = ({
	value,
	isDisabled,
	loading,
	onToggleChange,
	onFlagDismiss,
	flag,
	testId,
	toggleHeading,
	toggleDescription,
}: Props) => (
	<>
		<Toggle
			size="large"
			isChecked={value}
			isDisabled={isDisabled === true || loading}
			label={toggleHeading}
			testId={testId}
			onChange={onToggleChange}
		/>

		<Box
			paddingInlineStart="space.200"
			xcss={[labelStyles, isDisabled ? disableLabelColorStyles : labelColorStyles]}
		>
			<Label isDisabled={isDisabled}>{toggleHeading}</Label>
			{toggleDescription}
		</Box>

		{flag && (
			<FlagGroup onDismissed={onFlagDismiss}>
				<AutoDismissFlag {...flag} />
			</FlagGroup>
		)}
	</>
);

export default SearchTransitionToggle;

const labelStyles = xcss({
	marginTop: 'space.025',
});

const labelColorStyles = xcss({
	color: 'color.text',
});

const disableLabelColorStyles = xcss({
	color: 'color.text.disabled',
});

const lineHeight = typography.headingSizes.h500.lineHeight;
const fontSize = typography.headingSizes.h500.size;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Label = styled.label<{ isDisabled?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	lineHeight: `${lineHeight}px`,
	display: 'block',
	marginTop: 0,
	marginBottom: token('space.050', '4px'),
	fontWeight: 500,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		props.isDisabled ? token('color.text.disabled', colors.N200) : token('color.text', colors.N800),
});
